import { Component, HostListener, OnInit, TemplateRef, ViewChild, AfterViewInit } from '@angular/core';
import { SharedDataService } from './services/shared-data.service';
import { AuthServiceService } from './services/auth-service.service';
import { environment } from '../environments/environment';
import { AuthGuardService } from './services/auth-guard.service';
import { LoginService } from 'src/app/services/login/login.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewInit {
    title = 'Yiayia';
    @ViewChild('childModal') private childModal: TemplateRef<Object>;

    imgUrl: string;
    signedInUser: any;

    constructor(public sharedData: SharedDataService,
        private authService: AuthServiceService,
        private authGuardServive: AuthGuardService,
        private loginService: LoginService,
        private router: Router
    ) {
        if (environment.idleTime > 0) {
            this.sharedData.setTimeout();
            this.sharedData.userInactive.subscribe(() => {
                if (this.authGuardServive.isAuthenticated()) {
                    this.sharedData.openModal(this.childModal);
                    console.log('User has been inactive for ' + environment.idleTime + 's');
                }
            });

            this.sharedData.userInactiveLogOut.subscribe(() => {
                if (this.authGuardServive.isAuthenticated()) {
                    this.sharedData.closeModal();
                    this.authService.logoutUser();
                    console.log('User has been logged out');
                }
            });
        }
    }

    @HostListener('window:click') refreshUserState() {
        if (environment.idleTime > 0)
            this.sharedData.clearTimeout();
    }

    ngOnInit() {
        // Check if we're on a non-default route (deep link)
        // Use window.location.pathname because router.url isn't ready yet during ngOnInit
        const currentUrl = window.location.pathname;
        const isDeepLink = currentUrl !== '/' && currentUrl !== '/login' && !currentUrl.startsWith('/login/');

        // Skip navigation if we're on a deep link, so the user stays on their requested URL
        this.loginService.loadUserDetails(isDeepLink);
    }

    hideChildModal(): void {
        this.sharedData.closeModal();;
    }

    stay() {
        this.sharedData.closeModal();
        this.sharedData.clearTimeout();
    }

    logout() {
        this.sharedData.closeModal();
        this.authService.logoutUser();
    }

    ngAfterViewInit(): void {
        if (!environment.production) {
            const allContainers = Array.from(document.querySelectorAll('.container, .container-fluid'));
            const topLevelContainers = allContainers.filter(
                el => !el.closest('.container .container, .container-fluid .container, .container .container-fluid, .container-fluid .container-fluid')
            );

            if (topLevelContainers.length === 0) {
                console.warn('⚠️ No top-level .container or .container-fluid found in the current view.');
            }

            const nestedContainers = document.querySelectorAll(
                '.container .container, .container-fluid .container, .container .container-fluid, .container-fluid .container-fluid'
            );
            if (nestedContainers.length > 0) {
                console.warn('⚠️ Nested Bootstrap containers detected:', nestedContainers);
            } else {
                console.log('✅ No nested Bootstrap containers detected');
            }
        }
    }
}
